import config from '@config'

import {
    PERSONS_BENEFICIAL_OWNERS_TABLE_CHANGE,
    PERSONS_BENEFICIAL_OWNERS_TABLE_CHANGE_REQUEST,
    PERSONS_BENEFICIAL_OWNERS_TABLE_LOADING_TRUE,
    PERSONS_BENEFICIAL_OWNERS_TABLE_LOADING_FALSE,
    PERSONS_BENEFICIAL_OWNERS_TABLE_DATA_RECEIVED,
} from './constants'

export function personsBeneficialOwnersChanged(module, blockKey, id, level, queryParams) {
    return {
        type: PERSONS_BENEFICIAL_OWNERS_TABLE_CHANGE,
        data: {
            module,
            blockKey,
            id,
            level,
            queryParams,
        },
    }
}

export function personsBeneficialOwnersTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: PERSONS_BENEFICIAL_OWNERS_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: config?.api?.[module]?.[blockKey]?.block?.[4]?.uri,
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function personsBeneficialOwnersTableDataReceived(module, id, blockKey, customData) {
    return {
        type: PERSONS_BENEFICIAL_OWNERS_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function personsBeneficialOwnersTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: PERSONS_BENEFICIAL_OWNERS_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function personsBeneficialOwnersTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: PERSONS_BENEFICIAL_OWNERS_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
